module.exports = __webpack_public_path__ + "img/outdoorDualCurtainDetector.717f3f8e.webp";